import io from 'socket.io-client'

const socket = io(process.env.WS_URL, {
  withCredentials: true,
  transports: ['websocket']
})

socket.on('connect', function(){

     console.log(`Conectado al servidor`)
})



socket.on('disconnect', function(){

  console.log(`Desconectado del servidor`)
})




export default socket
